module.exports = __webpack_public_path__ + "img/vae_nano.e215880a.png";